var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-label',{staticClass:"ma-1",attrs:{"label":"","text":_vm.label,"icon":_vm.icon,"color":_vm.color},on:{"click":_vm.click}})}
var staticRenderFns = []

export { render, staticRenderFns }